import React, { Dispatch, SetStateAction } from "react";
import { CustomSlider, SliderContainer } from "./Slider.styles";
import FlutteringBird from "src/components/Bird/FlutteringBird";
import StandingBird from "src/components/Bird/StandingBird";
import { colors, fontWeights } from "src/tokens";
import { Guest } from "src/models/ticketingDashboard/Ticket";

export interface CustomSliderProps {
  guestCount: number,
  guestLimit: number;
  guests: Guest[],
  setGuestCount: Dispatch<SetStateAction<number>>,
  setGuests: Dispatch<SetStateAction<Guest[]>>,
  onGuestCountChange(value: number | number[]): void,
  originalGuests:  Guest[],
}

export const Slider = ({
  guestCount,
  guestLimit,
  guests,
  setGuestCount,
  setGuests,
  onGuestCountChange,
  originalGuests,
  ...rest
}: CustomSliderProps) => {

  return (
    <SliderContainer>
      <div style={{ display: "flex" }}>
        {
          [...Array(guestLimit ?? 0)].map((_, index) =>{
            if (index === 0) {
              return guestCount === 0
              ? <StandingBird key={`bird_${index}`} height={"24px"} width={"36.92px"}/>
              : <FlutteringBird key={`bird_${index}`} height={"24px"} width={"36.92px"}/>
            }

            return index + 1 <= guestCount
              ? <FlutteringBird key={`bird_${index}`} height={"24px"} width={"36.92px"}/>
              : <StandingBird key={`bird_${index}`} height={"24px"} width={"36.92px"}/>
          })
        }
      </div>
      <CustomSlider
        value={guestCount}
        defaultValue={guests.length}
        min={0}
        max={guestLimit}
        step={1}
        onChange={(_, value, __) => onGuestCountChange(value)}
      />
      <div style={{ display: "flex", gap: "8px" }}>
        <div style={{ color: colors["neutral.50"], fontWeight: fontWeights.semibold }}>+ {guestCount}</div>
        <div style={{ color: colors["neutral.500"] }}>Guest(s)</div>
      </div>
    </SliderContainer>
  );
};

export interface SliderProps extends React.ComponentProps<typeof Slider> {
  as?: React.ElementType;
}

Slider.displayName = "Slider";